import React, { useState } from 'react';
import { Document, Page, StyleSheet, PDFViewer, PDFDownloadLink, Font} from '@react-pdf/renderer';
import { Button, Loader, Modal } from 'semantic-ui-react';
import ReactDOMServer from 'react-dom/server';
import Html from 'react-pdf-html';
import { v4 as uuid } from 'uuid';
import { uploadFileType, workflowSubTask } from '../../app/api/types';
import agent from '../../app/api/agent';
import { useStore } from '../../app/stores/store';
import { historyInitialState } from '../../app/models/history';


Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: `${process.env.PUBLIC_URL}/assets/fonts/Roboto-Regular.ttf`,
      fontWeight: 'normal',
    },
    {
      src: `${process.env.PUBLIC_URL}/assets/fonts/Roboto-SemiBold.ttf`,
      fontWeight: 'bold',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Times-Roman',
    fontSize: 12,
    padding: 20,
  },
  table: {
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderCollapse: 'collapse',
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#bfbfbf',
  },
  tableCellHeader: {
    fontSize: 12,
    padding: 5,
    fontWeight: 'bold',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 10,
    padding: 5,
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    textAlign: 'center',
  },
});

interface HFCTaskReceiptModal {
  inspectModal: boolean;
  setInspectModal: (value: boolean) => void;
  filmConditions: any[];
  shippingPrep: workflowSubTask; 
  selectedId:any
  openComplete?: (param: number, directcomplete: boolean) => Promise<void>;
  rowData?:any;
  title?: string;
  handleStatus:(value:number)=> void;
}

const safeParseArray = (value?: string, context?: string) => {
  if (!value || value.trim() === '') {
    return [];
  }

  try {
    const parsedValue = JSON.parse(value);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    console.error(`Error parsing ${context || 'JSON'}:`, error, value);
    return [];
  }
};

const InspectionDetails: React.FC<HFCTaskReceiptModal> = ({ inspectModal, setInspectModal, filmConditions,selectedId, shippingPrep, rowData,title,handleStatus }) => {
  const{ElementStore, dashboardStore, activityStore, userStore} = useStore();
  const[isLoading, setISLoading] =useState(false)
  const inspectionDetailStatusItem:any = shippingPrep.elements.find((item: any) => item.elementName === 'Inspection Detail Status');
  let categories:any;
  let inspectionDetailStatus:any = [];
  if(inspectionDetailStatusItem){
   inspectionDetailStatus = safeParseArray(
    inspectionDetailStatusItem?.elementValue,
    'inspectionDetailStatus',
   );
    categories = inspectionDetailStatus.length > 0 ? Object.keys(inspectionDetailStatus[0][Object.keys(inspectionDetailStatus[0])[0]]) : [];
  }
    const task = shippingPrep.elements.find(item => item.elementName === 'Inspection Details');

    // const normalTask = shippingPrep.elements
    // // .filter(item => item.elementType !== "DynamicTable")
    // .sort((a, b) => a.elementIndex - b.elementIndex);

    const normalTask = shippingPrep.elements.map(item => {
      if (item.elementType === "DynamicTable") {
          // Remove "DynamicTable|" and parse the elementValue
          const updatedValue = item.elementValue.replace("DynamicTable|", "");
          
          // Parse the updated value
          const parsedValue = safeParseArray(updatedValue, 'dynamicTableElementValue');
          
          // Remove _uuid from parsedValue
          parsedValue.forEach((entry:any) => {
              delete entry._uuid_;
          });
  
          // Stringify the modified value
          const stringifiedValue = JSON.stringify(parsedValue).replace(/[[\]{}]/g, '') 
          .replace(/"/g, '')   
          .replace(/,/g, ', '); 
  
          return {
              ...item,
              elementValue: stringifiedValue // Assign the modified object back
          };
      }
      return item;
  })
  .sort((a, b) => a.elementIndex - b.elementIndex);
  
  
  
  // Use updatedElements as needed
  // console.log(updatedElements);
  

//     const Dynamictable = shippingPrep.elements.find(item => item.elementType === "DynamicTable");
// let ParsedDynamictable;
// if (Dynamictable) {
//     try {
//         ParsedDynamictable = Dynamictable.elementValue.replace("DynamicTable|", "");
//         JSON.parse(ParsedDynamictable)
//         // Use ParsedDynamictable as needed
//     } catch (error) {
//         console.error("Failed to parse elementValue:", error);
//     }
// } else {
//     console.warn("DynamicTable not found in elements.");
// }

// console.log(ParsedDynamictable)

  
  
    
    const elementValue:any = task?.elementValue;
    
    let arrayOfObjects = [];
        const jsonString = elementValue?.replace('DynamicTable|', '');
        if(!jsonString){
            console.error("jsonString is undefined or empty");
        } else {
            arrayOfObjects = safeParseArray(jsonString, 'inspectionDetailsTable');
        }
    const element = (
        <html>
          <body>
            <div style={{width: '150px', height: '70px', margin:"auto"}}>
                <img src="/assets/HFC.jpg" alt="" />
            </div>
            <h5 style={{textAlign: 'center', margin: '0',fontFamily: 'Roboto', fontWeight: 'bold'}}>{title}-{shippingPrep.subTaskName}</h5>
            {shippingPrep.subTaskName !== "Inspection Details" && (<>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 10, border: '1px solid #bfbfbf' }}>
                <tbody>
                <tr style={{  background: '#E7E9EB;' }}>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',   }}>
                   Description
                  </td>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                   Values
                  </td>
                </tr>
                {
                    normalTask.map((item: any) => (
                        <tr key={item.elementName}>
                            <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                                {item.elementName}
                            </td>
                            <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                                {item.elementValue}
                            </td>
                        </tr>
                    ))
                }

                </tbody>
            </table></>)}
            {shippingPrep.subTaskName === "Inspection Details" && (<>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 10, border: '1px solid #bfbfbf' }}>
                <tbody>
                <tr style={{  background: '#E7E9EB;' }}>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                   Reels
                  </td>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                  Total Footage
                  </td>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                   Overall Grade
                  </td>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse', fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                   Notes
                  </td>
                </tr>
                    {arrayOfObjects.map((item:any, index:any) => (
                <tr>
                        <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                            {item["Reel Barcodes"]}
                        </td>
                        <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                        {item["Total Footage"]}
                        </td>
                        <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                        {item["Overall Grade"]}
                        </td>
                        <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                        {item["Notes"]}
                         </td>
                </tr>
                    ))}
                </tbody>
            </table>

            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 10, border: '1px solid #bfbfbf' }}>
              <tbody>
                <tr style={{  background: '#E7E9EB;' }}>
                  <td style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'left', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                  S.No
                  </td>
                  {inspectionDetailStatus.map((film:any, index:any) => {
                    const filmKey = Object.keys(film)[0];
                    return (
                      <td key={index} style={{ fontSize: 10, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse',fontFamily: 'Roboto', fontWeight: 'bold',  }}>
                        {filmKey}
                      </td>   
                    );
                  })}
                </tr>
                {categories.map((category:any, idx:any) => (
                  <React.Fragment key={idx}>
                    <tr>
                      <td colSpan={inspectionDetailStatus.length + 1} style={{ fontSize: 11, fontWeight: 'bold',padding: 5, border: '1px solid #bfbfbf', borderCollapse: 'collapse',fontFamily: 'Roboto' }}>
                        {category}:
                      </td>
                    </tr>
                    {Object.keys(inspectionDetailStatus[0][Object.keys(inspectionDetailStatus[0])[0]][category]).map((property, propIndex) => (
                      <tr key={`${idx}-${propIndex}`}>
                        <td style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'left', borderCollapse: 'collapse' }}>
                          {property}
                        </td>
                        {inspectionDetailStatus.map((film:any, filmIndex:any) => {
                          const filmKey = Object.keys(film)[0];
                          const filmData = film[filmKey];
                          return (
                            <td key={`${filmKey}-${category}-${property}`} style={{ fontSize: 12, padding: 5, border: '1px solid #bfbfbf', textAlign: 'center', borderCollapse: 'collapse' }}>
                              {filmData[category][property] ? 'Yes' : 'No'}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table></>)
            }
          </body>
        </html>
      );
      
  

  const html = ReactDOMServer.renderToStaticMarkup(element);

  const PDFDocument = () => (
    <Document title={`${title} - ${shippingPrep.subTaskName}`}>
      <Page size="A4" style={styles.page}>
        <Html>{html}</Html>
      </Page>
    </Document>
  );

  
  const addToItemFiles = async (blobFile: Blob, fileName: string, data:any) => {
    setISLoading(true)
    if(shippingPrep.status ===2){
    let subTaskConst: uploadFileType = {
      id: '',
      files: [],
    };
    let response: any = [];
      const blobPDF: any = new Blob([blobFile], {
        type: 'application/pdf',
      });
      const pdfFile: any = new File([blobPDF], `${fileName}.pdf`, { type: 'application/pdf' });
      response = await agent.Files.uploadFile(pdfFile);
      Object.assign(response.data, { fileId: uuid() });
      response.data.id = uuid();
      response.data.fileName = fileName;
      subTaskConst = {
        // subTaskId: subTaskIdNo,
        id: selectedId,
        files: [
          {
            ...response.data,
            addedOn: new Date(),
          },
        ],
    }
    await ElementStore.HFCgeneratePdf(subTaskConst);
     
      await agent.HFC.HFCTaskElementUpdate(shippingPrep.elements)
      if(dashboardStore.dashboard.valueForL3Orders === "Services"){
        await  agent.HFC.HFCServiceStartTask(selectedId,shippingPrep.status)
        await activityStore.HFCServiceCount();
        await activityStore.HFCServiceloadActivitiesPagination(dashboardStore.dashboard.valueForL4Orders,1,"",5,[]);
        if(activityStore.ServiceCount.length > 1){
          const index = activityStore.ServiceCount.findIndex((item:any) => item.service === dashboardStore.dashboard.valueForL4Orders);
          if(index === -1){
            dashboardStore.dashboard.valueForL4Orders = activityStore.ServiceCount[0]?.service
          }else{
            dashboardStore.dashboard.valueForL4Orders = activityStore.ServiceCount[index]?.service
          }
        }else{
          dashboardStore.dashboard.valueForL4Orders = activityStore.ServiceCount[0]?.service
        }
      } 

      if(dashboardStore.dashboard.valueForL3Orders === "Shipping Prep"){
        await  agent.HFC.HFCTaskStatus(selectedId,shippingPrep.status);
        const payload={
          ...historyInitialState,
          itemId: rowData.asset_ID,
          status: `${userStore.user?.displayName} has completed the task ${shippingPrep.subTaskName} for the asset "${title}"`,
          dateTime: new Date().toISOString(),
          trackerFromTime: new Date().toISOString(),
        }
        await agent.HFC.HFCaddHistory(payload)
        await activityStore.HFCShippingPreploadActivitiesPagination(1,"", 5,[])
        dashboardStore.dashboard.valueForL3Orders = "Shipping"
    }
  }
    setISLoading(false)
    setInspectModal(false)
    }

  return (
    <Modal
      open={inspectModal}
      onOpen={() => setInspectModal(true)}
      trigger={<Button>Show Modal</Button>}
    >
      <Modal.Header>{title} - {shippingPrep.subTaskName}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
            <PDFViewer width="100%" height="600">
              <PDFDocument/>
            </PDFViewer>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
      <Button
      content="Close"
      onClick={async() => {
        setInspectModal(false)
        handleStatus(shippingPrep.status)
        if(dashboardStore.dashboard.valueForL3Orders === "Services"){
          await  agent.HFC.HFCServiceStartTask(selectedId,1)
        }else{
          await  agent.HFC.HFCTaskStatus(selectedId,1);
        }
      }}
      />
      {shippingPrep.status === 2 ?
      <PDFDownloadLink
          document={<PDFDocument />}
          fileName={`${shippingPrep.subTaskName}-${rowData.asset_ID}.pdf`}
          style={{ textDecoration: 'none' }}
        >
          {({ blob, loading }) => (
        <Button
          content={
            isLoading ? (
              <span>
                <Loader active inline size='tiny' /> OK
              </span>
            ) : (
              "OK"
            )
          }
          labelPosition="right"
          icon="checkmark"
          positive
          onClick={() => addToItemFiles(blob!,`${shippingPrep.subTaskName}_${rowData.asset_ID}`, PDFDocument)}
          disabled={isLoading}
        />)}
        </PDFDownloadLink> : <Button
          content="OK"
          labelPosition="right"
          icon="checkmark"
          positive
          onClick={() => setInspectModal(false)}
        />
        }
      </Modal.Actions>
    </Modal>
  );
};

export default InspectionDetails;
